import { MESSAGE_NAME } from '@/constants/message'

/**
 * 根据服务器返回的消息，得到前端适用的 MESSAGE_NAME
 * http://192.168.3.101/webot-dev/webot3/blob/xuwei/doc/%E4%BC%9A%E8%AF%9D%E6%B6%88%E6%81%AF.md
 * @param { String } detailType
 * @param { String | Object } content
 * @returns { String } - 前端适用的 MESSAGE_NAME
 */
export default function formatMessageName (detailType, content) {
    switch (detailType) {
        // S type: event
        case 'normal': return MESSAGE_NAME.EVENT_NORMAL
        case 'chat_notice': return MESSAGE_NAME.EVENT_CHAT_NOTICE
        case 'input_status': return MESSAGE_NAME.INPUT_STATUS //正在输入事件
        case 'readed': return MESSAGE_NAME.READED //已读事件
        case 'chat_status': return MESSAGE_NAME.EVENT_CHAT_STATUS
        case 'queue': return MESSAGE_NAME.EVENT_QUEUE
        case 'leave_comments': return MESSAGE_NAME.EVENT_LEAVE_MESSAGE
        case 'evaluation': return MESSAGE_NAME.EVENT_EVALUATION
        case 'retract': return MESSAGE_NAME.EVENT_WITHDRAW
        case 'session_monitor': return MESSAGE_NAME.EVENT_SESSION_MONITOR
        // S type: event

        // S type: base
        case 'text': return MESSAGE_NAME.TEXT
        case 'unknown': return MESSAGE_NAME.TEXT
        case 'image/png':
        case 'image/jpg':
        case 'image/jpeg':
        case 'image/gif':
        case 'image/svg':
        case 'image':
            return MESSAGE_NAME.IMAGE
        case 'audio':
        case 'audio/mp3':
            return MESSAGE_NAME.AUDIO
        // case 'audio_translation': return MESSAGE_NAME.AUDIO_TRANSLATION
        case 'audio_translation': return MESSAGE_NAME.TEXT // 历史记录的语音翻译 以 text 的形式展示
        case 'video/mp4':
        case 'video':
            return MESSAGE_NAME.VIDEO
        case 'application/xls':
        case 'application/xlsx':
        case 'application/doc':
        case 'application/docx':
        case 'application/ppt':
        case 'application/pptx':
        case 'application/pdf':
        case 'application/txt':
        case 'text/txt':
        case 'file':
            return MESSAGE_NAME.FILE
        case 'rich_text': return MESSAGE_NAME.RICH_TEXT
        case 'html': return MESSAGE_NAME.HTML
        case 'render_text': return MESSAGE_NAME.RENDER_TEXT
        case 'table': return MESSAGE_NAME.TABLE
        case 'select': return MESSAGE_NAME.SELECT
        case 'chat_invite': return MESSAGE_NAME.INVITE //会话邀请
        case 'showBtn': return MESSAGE_NAME.SHOWBTN //会话邀请
        case 'recommend': return getMessageOptionName(content.mode)
        case 'card': return getMessageSwiperName(content.mode)
        // E type: base

        default:
            return ''
    }
}

function getMessageOptionName (mode) {
    switch (mode) {
        // 推荐问题 统一组件
        case 'normal':
        case 'options':
        case 'no_answer': return MESSAGE_NAME.OPTION_NORMAL
    }
}

function getMessageSwiperName (mode) {
    switch (mode) {
        case 'small': return MESSAGE_NAME.SWIPER_ICON
        // case 'loop_recommends': return MESSAGE_NAME.SWIPER_SINGLE
        case 'full': // 和下方一致
        case 'full_recommends': return MESSAGE_NAME.SWIPER_IMG_TEXT
        case 'general': return MESSAGE_NAME.SWIPER_LIST
    }
}
